"use strict";

var _vue = require("vue");

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = require("vue-i18n");

var _vueI18n2 = _interopRequireDefault(_vueI18n);

require("es6-promise/auto");

var _vuex = require("vuex");

var _vuex2 = _interopRequireDefault(_vuex);

var _translations = require("./translations/translations");

var _translations2 = _interopRequireDefault(_translations);

var _functions = require("./utilities/functions");

var _vueScrollto = require("vue-scrollto");

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _buefy = require("buefy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueScrollto2.default);
_vue2.default.use(_buefy.Table);

var locale = window.globals.user && window.globals.user.locale ? window.globals.user.locale : (0, _functions.storageAvailable)("localStorage") && localStorage.getItem("locale") ? localStorage.getItem("locale") : "sv";

// Create VueI18n instance with options
var i18n = new _vueI18n2.default({
  locale: locale, // set default locale
  messages: _translations2.default // set locale messages
});

var store = new _vuex2.default.Store({
  state: {
    locale: locale,
    requestErrors: {},
    testTypeEditor: {
      isValid: true
    }
  },
  mutations: {
    changeLocale: function changeLocale(state, payload) {
      state.locale = payload;
    },
    addRequestErrors: function addRequestErrors(state, payload) {
      state.requestErrors[payload.action] = payload.data;
    },
    changeTestTypeEditorStatus: function changeTestTypeEditorStatus(state, payload) {
      state.testTypeEditor.isValid = payload;
    }
  },
  getters: {
    pullRequestErrorsAndOldInputByAction: function pullRequestErrorsAndOldInputByAction(state) {
      return function (action) {
        var data = _.get(state.requestErrors, action, {
          errors: [],
          oldInput: []
        });

        delete state.requestErrors[action];

        return data;
      };
    }
  }
});

var app = new _vue2.default({
  el: "#app",

  data: {
    idleTime: 0,
    g: window.globals
  },

  i18n: i18n,

  store: store,

  mounted: function mounted() {
    if (!(window.location.pathname === "/login")) {
      // this.logOutOnInactivity();

      var vm = this;
      //Zero the idle timer on mouse movement.

      var appElement = document.getElementById("app");
      var events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
      events.forEach(function (eventName) {
        appElement.addEventListener(eventName, function () {
          return vm.idleTime = 0;
        }, true);
      });
    }

    if (window.location.pathname !== "/ie-is-not-allowed" && this.isIE()) {
      window.location.href = "/ie-is-not-allowed";
    }

    if (window.location.href.indexOf("employee") === -1) {
      this.clearLocalStorage("employeeList");
    }
  },


  methods: {
    logOutOnInactivity: function logOutOnInactivity() {
      //Increment the idle time counter every minute.
      setInterval(this.timerIncrement, 60000); // 1 minute
    },
    timerIncrement: function timerIncrement() {
      this.idleTime++;

      if (window.Fn.isAdmin() || window.Fn.isTestLeader()) {
        if (this.idleTime >= 120) {
          // 2 hours
          window.location.href = "/logout";
        }
      } else {
        if (this.idleTime >= 60) {
          // 1 hour
          window.location.href = "/logout";
        }
      }
    },
    isIE: function isIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      if (msie !== -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
      }

      return false;
    },
    clearLocalStorage: function clearLocalStorage(key) {
      localStorage.removeItem(key);
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/app.js
// module id = sV/x
// module chunks = 0 1